"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var BaseTableRow_1 = __importDefault(require("atomicComponents/atoms/Table/BaseTableRow"));
var Table_1 = require("atomicComponents/atoms/Table/Table");
var general_1 = require("utils/general");
// TODO: replace styles on TableRow when all use the tableConf format
exports.default = (0, styles_1.styled)(BaseTableRow_1.default, {
    shouldForwardProp: (0, general_1.omitProps)('isHidden', 'sizing', 'highlight', 'hoverable', 'selected', 'disabled', 'markRemoved', 'highlightInputs'),
})(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme, onClick = _a.onClick, hoverable = _a.hoverable, sizing = _a.sizing, highlight = _a.highlight, selected = _a.selected, disabled = _a.disabled, markRemoved = _a.markRemoved, highlightInputs = _a.highlightInputs;
    return (__assign(__assign(__assign(__assign(__assign(__assign({ cursor: onClick ? 'pointer' : 'default', position: 'relative', borderRadius: 8, backgroundColor: theme.palette.common.white }, selected && {
        backgroundColor: (_b = theme.palette.azzurro) === null || _b === void 0 ? void 0 : _b.light,
        '> .stickyCell': { backgroundColor: (_c = theme.palette.azzurro) === null || _c === void 0 ? void 0 : _c.light },
        '.showOnHover': { visibility: 'hidden' },
    }), disabled && {
        '& > div > *': {
            opacity: 0.3,
            img: { filter: 'grayscale(100%)' },
        },
    }), markRemoved && {
        ':not(:hover) > div:not(.skipMarkRemoved)': {
            color: (_d = theme.palette.neutral) === null || _d === void 0 ? void 0 : _d.main,
            'img, svg': { filter: 'grayscale(100%)', opacity: 0.3 },
        },
    }), { ':hover': selected ? undefined : (__assign(__assign(__assign({}, (onClick || hoverable) && !disabled && {
            backgroundColor: theme.palette.roseQuartz.A100,
            '> .stickyCell': { backgroundColor: theme.palette.roseQuartz.A100 },
        }), highlightInputs && { '.highlightInput:not(:hover)': { borderColor: theme.palette.primary.light } }), { '.showOnHover': { opacity: 1 }, '.displayOnHover': { display: 'block' } })), fontSize: sizing === 'dense' ? theme.spacing(Table_1.DEFAULT_FONT_SIZE_SM) : undefined, ':focus-visible': __assign(__assign({}, theme.focusVisibleStyles), { zIndex: 3 }) }), highlight && {
        boxShadow: "0px 0px 0px 2px rgba(255, 255, 255, 0.9), 0px 0px 0px 3px ".concat(theme.palette.primary.main),
        outlineColor: 'transparent',
    }), { '& > div:first-child': {
            borderTopLeftRadius: 8,
            borderBottomLeftRadius: 8,
        }, '& > div:last-child': {
            borderTopRightRadius: 8,
            borderBottomRightRadius: 8,
        } }));
});
